import { render, staticRenderFns } from "./usedModal.vue?vue&type=template&id=270b970b&scoped=true&"
import script from "./usedModal.vue?vue&type=script&lang=js&"
export * from "./usedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b970b",
  null
  
)

export default component.exports